import React, { Fragment } from 'react';
import { useInView } from 'react-intersection-observer';
import PageTitle from '../../components/pagetitle/PageTitle'
import Navbar from '../../components/Navbar/Navbar'
import Scrollbar from '../../components/scrollbar/scrollbar';
import About4 from '../../components/about4/about4';
import MissionSection from '../../components/MissionSection/MissionSection';
import Targetarea from '../../components/Targetarea/Targetarea';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo.png'


const AboutPage = () => {
    const [missionRef, missionInView] = useInView({
        threshold: 0.2,
        triggerOnce: true,
        rootMargin: '-50px'
    });

    const [targetRef, targetInView] = useInView({
        threshold: 0.2,
        triggerOnce: true,
        rootMargin: '-50px'
    });

    const [aboutRef, aboutInView] = useInView({
        threshold: 0.2,
        triggerOnce: true,
        rootMargin: '-50px'
    });

    return (
        <Fragment>
            <Navbar hclass={'header-style-1'} Logo={Logo} btnClass={'theme-btn-s1'} />
            <PageTitle pageTitle={'About Us'} pagesub={'About'} />
            
            <div ref={aboutRef} className={`fade-in-section ${aboutInView ? 'is-visible' : ''}`}>
                <About4 />
            </div>

            <div ref={missionRef} className={`fade-in-section ${missionInView ? 'is-visible' : ''}`}>
                <MissionSection />
            </div>

            <div ref={targetRef} className={`fade-in-section ${targetInView ? 'is-visible' : ''}`}>
                <Targetarea />
            </div>

            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default AboutPage;
